import { useEffect } from "react";
import PageHeader from "@/components/PageHeader";
import Reveal from "@/components/Reveal";
import { COMPANY } from "@/data/site";

const CONTENT = {
  privacy: {
    title: "Privacy Policy",
    path: "/privacy-policy",
    sections: [
      {
        h: "Information we collect",
        p: "When you contact Click World Online through this website, we collect the details you choose to share — such as your name, email address, phone number, company, website and message — solely to respond to your enquiry.",
      },
      {
        h: "How we use it",
        p: "Your information is used only to communicate with you about your enquiry and, if you become a client, to deliver our services. We do not sell, rent or trade your personal information to third parties.",
      },
      {
        h: "Data security",
        p: "Enquiry details are stored securely and access is limited to the Click World Online team. We retain enquiry records only as long as needed for business communication.",
      },
      {
        h: "Third-party services",
        p: "This website embeds Google Maps and links to our official Instagram and Facebook profiles. These services are governed by their own privacy policies.",
      },
      {
        h: "Your choices",
        p: `You may ask us to update or delete your contact details at any time by emailing ${COMPANY.email} or calling ${COMPANY.phone1}.`,
      },
    ],
  },
  terms: {
    title: "Terms & Conditions",
    path: "/terms-and-conditions",
    sections: [
      {
        h: "Use of this website",
        p: "This website presents the services and work of Click World Online, a digital marketing agency based in Mansa, Punjab, India. By using this website you agree to these terms.",
      },
      {
        h: "Services",
        p: "Specific services, deliverables, timelines and pricing are agreed individually with each client through a written proposal or agreement. Nothing on this website constitutes a binding offer or a guarantee of specific results.",
      },
      {
        h: "Intellectual property",
        p: "The Click World Online name, logo, content and design of this website are the property of Click World Online and may not be reproduced without written permission.",
      },
      {
        h: "External links",
        p: "This website links to external platforms including Google Maps, Instagram and Facebook. We are not responsible for the content or availability of external websites.",
      },
      {
        h: "Contact",
        p: `Questions about these terms can be sent to ${COMPANY.email} or discussed over ${COMPANY.phone1}.`,
      },
    ],
  },
  disclaimer: {
    title: "Disclaimer",
    path: "/disclaimer",
    sections: [
      {
        h: "General information",
        p: "The content on this website is provided for general information about Click World Online and its services. While we keep it accurate and up to date, we make no representations or warranties of any kind about completeness or accuracy.",
      },
      {
        h: "No guaranteed outcomes",
        p: "Digital marketing results depend on many factors — market, competition, budget, platforms and timing. Click World Online does not guarantee specific rankings, traffic volumes, lead counts or revenue outcomes.",
      },
      {
        h: "Portfolio & case studies",
        p: "Client names shown on this website are displayed with authorization. Performance figures are published only where they can be verified, and detailed documentation is shared on request.",
      },
      {
        h: "360° content",
        p: "360° experiences are hosted and rendered by Google Maps / Google Street View. Availability and rendering of these embeds are subject to Google's services.",
      },
      {
        h: "Liability",
        p: "Click World Online is not liable for any loss or damage arising from the use of this website or reliance on its content.",
      },
    ],
  },
};

const Legal = ({ page }) => {
  const doc = CONTENT[page];
  useEffect(() => {
    document.title = `${doc.title} — Click World Online`;
  }, [doc]);
  return (
    <>
      <PageHeader eyebrow="Legal" title={doc.title} text={`Last updated: July 2026 — ${COMPANY.name}, ${COMPANY.address2}`} />
      <section className="bg-navy-deep">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 py-20 lg:py-28 flex flex-col gap-12">
          {doc.sections.map((s, i) => (
            <Reveal key={s.h} delay={0.04 * i}>
              <div data-testid={`legal-section-${i}`}>
                <h2 className="font-display text-2xl font-extrabold text-mist tracking-tight">{s.h}</h2>
                <p className="mt-4 text-slatec leading-relaxed">{s.p}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
    </>
  );
};

export default Legal;
